import React from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useSession } from "./PrvateRouteHelperHook";
import { ROUTE_URLS } from "../../constants/consts";

export const ConditionalRoute: React.FC = () => {
  const { isAuthenticated } = useSession();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  if (isAuthenticated === null) {
    return <></>;
  }

  if (isAuthenticated) {
    return <Outlet />;
  }

  if (token) {
    return <Outlet />;
  }

  return <Navigate to={ROUTE_URLS.LANDING_PAGE} />;
};
